import React, {useEffect, useState} from "react";
import ReactInputMask from "react-input-mask";
import AppDatePicker from "./AppDatePicker";
import {
    Button,
    Container,
    Dimmer,
    Form,
    FormButton,
    Grid,
    Header,
    InputOnChangeData,
    Loader,
    Message,
    Modal
} from "semantic-ui-react";

export interface Time {
    hour: number,
    minute: number
}

interface Props {
    value?: Time;
    onChange?: (value?: Time) => void;
    readOnly?: boolean;
}

const AppTimePicker = (props: Props) => {
    const leftPad = (number: number, targetLength: number): string => {
        let output = number.toString();
        while (output.length < targetLength) {
            output = '0' + output;
        }
        return output;
    }

    const getTimeText = (value?: Time): string | undefined => {
        if (value)
            return `${leftPad(value.hour, 2)}:${leftPad(value.minute, 2)}`;
        else
            return '';
    }

    const [text, setText] = useState<string | undefined>(props.value ? getTimeText(props.value!) : undefined)

    useEffect(() => {
        const s = getTimeText(props.value);
        if (text != s)
        setText(s);
    }, [props.value]);

    return (
        <ReactInputMask
            mask={'99:99'}
            disabled={props.readOnly}
            alwaysShowMask={false}
            value={text}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                let s: string = e.target.value;
                setText(s);
                let newValue: Time | undefined;
                if (s.length == 5 && (s.indexOf("_") < 0)) {
                    let hours = parseInt(s.substring(0, 2), 10);
                    let minutes = parseInt(s.substring(3, 5), 10);
                    if (!isNaN(hours) && !isNaN(minutes)) {
                        hours = Math.max(0, Math.min(23, hours));
                        minutes = Math.max(0, Math.min(59, minutes));
                        newValue = {hour: hours, minute: minutes};
                        setText(getTimeText(newValue));
                    }
                }
                if (props.onChange && (newValue != props.value))
                    props.onChange(newValue);
            }}>
            {(inputProps: any) => <input {...inputProps} placeholder={"Время"} />}
        </ReactInputMask>);
}


export default AppTimePicker;